module.exports = __webpack_public_path__ + "static/img/server-weixin.3b7e523.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/server-weixin.png
// module id = ziMH
// module chunks = 0